import React from 'react';

import { Tag } from 'antd';
import { Popover } from 'antd';

import styled from 'styled-components';

import { showTime, showDate } from '@libs/NwMoment';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import CreatedBy from '@components/CreatedBy/CreatedBy';
import LastEditedBy from '@components/CreatedBy/LastEditedBy';
import EventTypeTag from '@components/EventDetails/EventTypeTag';
import NwEllipsis from '@components/Gui/NwEllipsis';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables.js';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const MeetingEventContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    border-bottom: ${StyleVariables.DefaultBorder};
    min-height: 3rem;

    &.agenda-event-selected {
    }
`;

const MeetingEventContent = styled.div`
    border-left: ${StyleVariables.DefaultBorder};
    padding: 0.25em 0.5em;
    min-height: 3rem;
    flex: 1 0 0;
    opacity: ${(props) => props.isAvailable && 0.5};

    .ant-tag {
        margin-right: 0;
    }

    small {
        display: block;
        font-weight: normal;
        font-size: 0.75rem;
    }
`;

const MeetingEventTime = styled.div`
    text-transform: uppercase;
    padding: 0.25em 0.5em 0.25em 0;
    white-space: nowrap;
    min-width: 7rem;
    text-align: right;
    opacity: ${(props) => props.isAvailable && 0.5};

    span {
        display: block;
        font-size: 1em;

        &.start-time {
            font-weight: bold;
        }
        &.reminder {
            font-weight: bold;
            color: ${StyleVariables.DangerColor};
            font-size: 0.6em;
        }
    }
    small {
        display: block;
        font-weight: normal;
        font-size: 0.75rem;
    }
    div.end-date {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        svg {
            margin-right: 1em;
        }
    }
    div.started-date {
        display: block;
    }
`;

const EventDetailsContainer = styled.div`
    max-width: 440px;

    div {
        font-size: 0.9rem;
        margin-bottom: 0.15em;
        display: flex;
        border-bottom: ${StyleVariables.DefaultBorder};
        span {
            font-weight: bold;
            min-width: 8em;
        }
        em {
            font-style: normal;
        }
    }
`;

const Title = styled.div`
    ${(props) => (props.cancel ? props.theme.RedLineThrough(1) : 'text-decoration: none;')}
    display: inline;
`;

const EventTypeTagContainer = styled.div`
    display: inline;
    margin-right: 8px;

    .ant-tag {
        background: #fafafa;
    }
`;

const Date = styled.h1`
    font-size: 1.1rem;
    padding-top: 0.5rem;
    flex: 1 0 0;
    line-height: 1em;
`;

const MeetingEventItem = (props) => {
    const { event, onSelectEvent, placement } = props;

    const st_string = event.StartDate;
    const et_string = event.EndDate;
    //TODO: change with TypeName or TypeValue when Updated
    //const eventtimetype = eventTimeType(event.TypeValue)

    const writeTime = () => {
        return (
            <>
                <span className="start-time">{showTime(st_string)}</span>
                <div className="end-date">
                    <span>
                        <NwIcon icon={byPrefixAndName.fasl['arrow-to-right']} size="xs" />
                    </span>
                    <span className="end-time">{showTime(et_string)}</span>
                </div>
            </>
        );
    };

    const popoverContent = (
        <EventDetailsContainer>
            <div>
                <span>ID</span>
                <em>{event.ID}</em>
            </div>
            {event.Title && (
                <div>
                    <span>Title</span>
                    <em>{event.Title}</em>
                </div>
            )}
            <div>
                <span>Created</span>
                <em>
                    <CreatedBy textonly object={event} extra="" />
                </em>
            </div>
            <div>
                <span>Last modified</span>
                <em>
                    <LastEditedBy textonly object={event} extra="" />
                </em>
            </div>
            {event.Description && (
                <div>
                    <span>Description</span>
                    <em>{event.Description}</em>
                </div>
            )}
            {event.Notes && (
                <div>
                    <span>Notes</span>
                    <em>{event.Notes}</em>
                </div>
            )}
        </EventDetailsContainer>
    );

    return (
        <Popover
            content={popoverContent}
            placement={placement || 'left'}
            title={<EventTypeTag event={event} type="Meeting" />}
        >
            <Date>{showDate(event.StartDate, 'ext-notime')}</Date>
            <MeetingEventContainer onClick={() => onSelectEvent(event)}>
                <MeetingEventTime>{writeTime()}</MeetingEventTime>
                <MeetingEventContent>
                    <EventTypeTagContainer>
                        <Tag>{event.TravelPlan.Name}</Tag>
                    </EventTypeTagContainer>
                    <Title>{getContactName(event.ContactID)}</Title>
                    <small>
                        <NwEllipsis text={event.Description} rows={2} />
                    </small>
                </MeetingEventContent>
            </MeetingEventContainer>
        </Popover>
    );
};

export default MeetingEventItem;
